import * as RadixSwitch from '@radix-ui/react-switch';
import { cn } from '@/shared/lib/cn';
import type { ComponentProps } from 'react';

export function Switch({ className, ...props }: ComponentProps<typeof RadixSwitch.Root>) {
  return (
    <RadixSwitch.Root
      className={cn(
        'bg-border-strong data-[state=checked]:bg-brand-600 focus-visible:ring-ring relative h-5 w-9 shrink-0 rounded-full transition-colors focus-visible:ring-2 focus-visible:outline-none',
        className,
      )}
      {...props}
    >
      <RadixSwitch.Thumb className="block h-4 w-4 translate-x-0.5 rounded-full bg-white shadow transition-transform data-[state=checked]:translate-x-[18px]" />
    </RadixSwitch.Root>
  );
}
